export default function initCubeForm() {
	const form = document.getElementById("cube__progress--form");
	const steps = document.getElementsByClassName("js-progress");
	const previousButton = document.getElementsByClassName("js-prev");
	const nextButton = document.getElementsByClassName("js-next");
	const submitButton = document.getElementsByClassName("validate");
	const buttonGroup = document.getElementsByClassName("button--group");
	const showSummary = document.querySelector(".show__summary");
	const summary = document.querySelector(".summary");
	const totalSteps = 4;
	let currentStep = 1;

	for (let i = 0; i < steps.length; ++i) {
		steps[i].addEventListener("click", () => {
			if (steps[i].classList.contains('enabled')) {
				goToStep(i + 1);
			}
		});
	}

	document.body.addEventListener('goNext', goNext);

	previousButton.onclick = goPrevious;
	// nextButton.onclick = goNext;
	//
	// for (const nextBtn of nextButton) {
	// 	nextBtn.onclick = goNext;
	// }

	for (const prevBtn of previousButton) {
		prevBtn.onclick = goPrevious;
	}

	function goNext(e) {
		e.preventDefault();

		// add complete class to done steps
		var originalCurrentStep = currentStep;
		steps[originalCurrentStep -1].classList.add("complete");

		currentStep += 1;
		if (currentStep > 0) {
			goToStep(currentStep);
			progressRadial(currentStep);
		}
	}

	function goPrevious(e) {
		showSummary.classList.remove('active');
		summary.classList.remove('active');
		if (currentStep > 1) {
			e.preventDefault();
			currentStep -= 1;
			goToStep(currentStep);
			progressRadial(currentStep);
		}
	}

	function goToStep(stepNumber) {

		currentStep = stepNumber;
		let tabPanel = document.getElementsByClassName("tab__panel");
		let inputs = document.getElementsByClassName(`step${currentStep}`);
		let indicators = document.getElementsByClassName("js-progress");

		for (let i = indicators.length - 1; i >= currentStep; --i) {
			indicators[i].classList.remove("active");
		}

		for (let i = 0; i < currentStep; ++i) {
			indicators[i].classList.add("active");
			indicators[i].classList.add("enabled");
		}

		//hide all input
		for (let i = 0; i < tabPanel.length; ++i) {
			hide(tabPanel[i]);
		}

		//only show the right one
		for (let i = 0; i < inputs.length; ++i) {
			show(inputs[i]);
			history.pushState({state:stepNumber}, "Stap"+stepNumber, "#stap"+stepNumber);
		}

	 if(currentStep === totalSteps) {
			enableButtons(previousButton);
			disableButtons(nextButton);
			showButtons(submitButton);
			startButtonGroup(buttonGroup);
		}
			//else if first step
		else if (currentStep === 1) {
			disableButtons(previousButton);
			enableButtons(nextButton);
			hideButtons(submitButton);
			endButtonGroup(buttonGroup);
		} else {
			enableButtons(previousButton);
			enableButtons(nextButton);
			hideButtons(submitButton);
			endButtonGroup(buttonGroup);
		}
	}

	function show(tab) {
		tab.classList.remove("hidden");
		tab.classList.add("currentTab");
	}

	function hide(tab) {
		tab.classList.add("hidden");
		tab.classList.remove("currentTab");
	}

	function enableButtons(elements) {
		for (const elem of elements) {
			elem.classList.remove("disabled", "hidden");
			elem.disabled = false;
		}
	}

	function startButtonGroup(elements) {
		for (const elem of elements) {
			elem.classList.add("buttonStart");
		}
	}

	function endButtonGroup(elements) {
		for (const elem of elements) {
			elem.classList.remove("buttonStart");
		}
	}


	function disableButtons(elements) {
		for (const elem of elements) {
			elem.classList.add("disabled", "hidden");
			elem.disabled = true;
		}
	}

	function showButtons(elements) {
		for (const elem of elements) {
			elem.classList.remove("hidden");
		}
	}

	function hideButtons(elements) {
		for (const elem of elements) {
			elem.classList.add("hidden");
		}
	}

	function progressRadial(stepNumber) {
		var totalProgress, progress, singleStep;
		currentStep = stepNumber;
		const progressPosition = document.querySelectorAll(".progress--position");
		const circles = document.querySelectorAll(".progress__radial");
		for (var i = 0; i < circles.length; i++) {
			totalProgress = circles[i].querySelector("circle").getAttribute("stroke-dasharray");
			singleStep = totalProgress / totalSteps; 
			
			// step = circles[i].parentElement.getAttribute("data-percent");
			circles[i].querySelector(".progress__radial--bar").style[
				"stroke-dashoffset"
			] = (totalProgress - (singleStep * currentStep));
			const stepPosition = currentStep + '/' + totalSteps;
			progressPosition[0].innerText = stepPosition;
		}
	}
	window.addEventListener('hashchange', doSomethingWithChangeFunction);
	function doSomethingWithChangeFunction() {
		var currentHash = window.location.hash;
		var stepnumber = currentHash.replace("#stap", "");
		var stepnubmerInArrayFormat = parseInt(stepnumber);
		if (steps[stepnubmerInArrayFormat] && steps[stepnubmerInArrayFormat].classList.contains('enabled')) {
			goToStep(stepnubmerInArrayFormat);
		}
	}
}
